export const VIMEO_ACCESS_TOKEN = process.env.REACT_APP_VIMEO_ACCESS_TOKEN || "";
export const VIMEO_MY_VIDEOS_API_URL = "https://api.vimeo.com/me/videos";
export const VIMEO_VIDEOS_API_URL = "https://api.vimeo.com/videos";
export const VIMEO_PLAYER_URL = "https://player.vimeo.com/video";

export const VIMEO_ACTIONS = {
  NEW_VIDEO: "NEW_VIDEO",
  DELETE_VIDEO: "DELETE_VIDEO"
};
